import './SettingModal.scss';

import { observer } from 'mobx-react';
import React from 'react';
import { useNavigate } from 'react-router';
import { academyDomain, attendanceDomain } from 'src/domain';
import { Auth } from 'src/domain_v2/auth';
import { ROUTE_NAME } from 'src/RouteName';
import { soundPreference } from 'src/utils/soundPreference';

import { ReactComponent as CloseIcon } from '/public/images/svgs/icon_close.svg';

import { ConfirmModal, modalStore } from '..';
import EnterExitManageModal from '../EnterExitManageModal';

const SettingModal = () => {
  const navigate = useNavigate();

  const onConfirm = (guide: React.ReactNode, onConfirm: () => void) => {
    modalStore.closeModal();
    modalStore.openModal(<ConfirmModal guide={guide} onConfirm={onConfirm} />);
  };

  const onChangeViewStudent = () => {
    modalStore.closeModal();
    attendanceDomain.toggleViewStudentList();
  };

  const closeCurrentModalAndOpenEnterExitManageModal = () => {
    modalStore.closeModal();
    modalStore.openModal(<EnterExitManageModal />);
  };

  return (
    <div className="setting__modal">
      <h3 className="setting__title">설정</h3>
      <button className="setting__modal--close" onClick={() => modalStore.closeModal()}>
        <CloseIcon />
      </button>
      <div className="setting__option--wrap">
        <button
          className="option__item hide__option--isMobile"
          onClick={() => {
            onConfirm(
              <>
                입퇴실 기록이 보이는 영역을&nbsp;
                {attendanceDomain.isViewList === 'VIEW' ? '숨기려면' : '보이려면'}
                <br />
                매쓰플랫 선생님 앱 비밀번호를 입력해주세요.
              </>,
              () => onChangeViewStudent(),
            );
          }}>
          입퇴실 기록&nbsp;
          {attendanceDomain.isViewList === 'VIEW' ? '숨기기' : '보여주기'}
        </button>
        <button
          className="option__item"
          disabled={!academyDomain.hasCellPhone}
          onClick={() => {
            onConfirm(
              <>
                입퇴실 문자를 설정하려면
                <br />
                매쓰플랫 선생님 앱 비밀번호를 입력해주세요.
              </>,
              closeCurrentModalAndOpenEnterExitManageModal,
            );
          }}>
          입퇴실 문자 관리
        </button>
        <button
          className="option__item"
          onClick={() => {
            onConfirm(
              <>
                학생 로그인 아이디를 관리하려면 <br />
                매쓰플랫 선생님 앱 비밀번호를 입력해주세요.
              </>,
              () => {
                navigate(ROUTE_NAME.STUDENT_LIST);
                modalStore.closeModal();
              },
            );
          }}>
          학생 로그인 아이디 관리
        </button>
        <button
          className="option__item"
          onClick={() => {
            onConfirm(
              <>
                출석 효과음을 변경하려면
                <br />
                매쓰플랫 선생님 앱 비밀번호를 입력해주세요.
              </>,
              () => {
                soundPreference.toggle();
                modalStore.closeModal();
              },
            );
          }}>
          {soundPreference.getToggleLabel()}
        </button>
        <button
          className="option__item"
          onClick={() => {
            onConfirm(
              <>
                로그아웃을 하기 위해
                <br />
                매쓰플랫 선생님 앱 비밀번호를 입력해주세요.
              </>,
              async () => {
                // 로컬 토큰만 지우면 서버의 refresh token이 만료 때까지 살아남아
                // 반납·교체한 태블릿에서 새어나간 토큰으로 재발급이 계속 된다.
                // logout()은 finally에서 clearToken()을 하므로 API가 실패해도
                // 로컬 토큰은 지워지고 로그인 화면으로 넘어간다.
                await Auth.authService.logout();
                modalStore.closeModal();
                window.location.pathname = ROUTE_NAME.LOGIN;
              },
            );
          }}>
          로그아웃
        </button>
      </div>
    </div>
  );
};

export default observer(SettingModal);
